import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/bitacora/bitacora';
import BitacoraDetalle from './BitacoraVer';

const mstp = state => {
    return {...state.bitacora}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(BitacoraDetalle)
